module.exports = __webpack_public_path__ + "static/media/22ESCWA18.6d537d5a.jpg";